import styles from "./Footer.module.scss";
import { useIntl } from "react-intl";
import MiscellaneousQuestionCircle from "../../../../common/icons/MiscellaneousQuestionCircle.tsx";
import { useState } from "react";
import RedeemDialog from "../../actions/redeem/RedeemDialog.tsx";
import SocialChat from "../../../../common/icons/SocialChat.tsx";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import HelpDialogSwitcher from "../../common/help/HelpDialogSwitcher.tsx";
import MiscellaneousCheckmarkCircle from "../../../../common/icons/MiscellaneousCheckmarkCircle.tsx";

export default function Footer() {
  const intl = useIntl();
  const [isRedeemDialogOpen, setIsRedeemDialogOpen] = useState(false);
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);
  const brand = useBrandLoaderData();

  const links = [
    {
      icon: <MiscellaneousCheckmarkCircle />,
      text: intl.formatMessage({ defaultMessage: "Redeem Code" }),
      onClick: () => setIsRedeemDialogOpen(true),
      enabled: brand.RedeemCode.enabled,
    },
    {
      icon: <MiscellaneousQuestionCircle />,
      text: intl.formatMessage({ defaultMessage: "Help" }),
      onClick: () => setIsHelpDialogOpen(true),
      enabled: true,
    },
    {
      icon: <SocialChat />,
      text: intl.formatMessage({ defaultMessage: "Feedback" }),
      href:
        brand.Feedback.custom_url ||
        "https://surveys.delighted.com/c/u/bINqxkm0",
      enabled: brand.Feedback.enabled,
    },
  ].filter((el) => el.enabled);

  return (
    <>
      <ul className={styles.footerArea}>
        {links.map((link) => (
          <li key={link.text}>
            <BaseLinkOrButton
              onClick={link.onClick}
              href={link.href}
              className={clsx(styles.button, "vst-icon-with-text")}
            >
              {link.icon}
              {link.text}
            </BaseLinkOrButton>
          </li>
        ))}
      </ul>
      {isRedeemDialogOpen && (
        <RedeemDialog onRequestClose={() => setIsRedeemDialogOpen(false)} />
      )}
      {isHelpDialogOpen && (
        <HelpDialogSwitcher onRequestClose={() => setIsHelpDialogOpen(false)} />
      )}
    </>
  );
}
